import { createApi } from '@reduxjs/toolkit/query/react'

import { rtkBaseQuery } from 'Src/api'

export const trainingApi = createApi({
  baseQuery: rtkBaseQuery,
  reducerPath: 'trainingApi',
  tagTypes: ['TrainingPhrases'],
  refetchOnMountOrArgChange: true,
  endpoints: (builder) => ({
    listTraining: builder.query({
      query: (params) => {
        return {
          method: 'GET',
          url: '/v1/training/',
          params
        }
      },
      providesTags: ['TrainingPhrases']
    }),
    updateReviewStatus: builder.mutation({
      query: (data) => {
        const { id, ...payload } = data
        return {
          method: 'PATCH',
          url: `v1/training/${id}/review-status`,
          body: payload
        }
      },
      invalidatesTags: ['TrainingPhrases']
    })
  })
})

export const { useListTrainingQuery, useUpdateReviewStatusMutation } = trainingApi

export default trainingApi
